<template>
    <section class="wrapper param-layout">
        <Row :gutter="20">
            <Col span="12">
            <Form :model="form1" label-position="right" :label-width="100">
                <Row>
                    <Col span="10">
                    <FormItem label="字典编码">
                        <Input type="text" v-model="form1.value1"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem label="字典名称">
                        <Input type="text" v-model="form1.value2"></Input>
                    </FormItem>
                    </Col>
                    <Col span="2">
                    <Button type="primary" :loading="loading" @click="sysParamSelect">查询</Button>
                    </Col>
                </Row>
            </Form>
            <!-- <Table highlight-row 
                    border 
                    :columns="columns1"
                    @on-current-change="handleCurrentChange" 
                    @on-selection-change='onSelectionChange'
                    :data="data1">
                <div slot="header" style="padding: 0 10px;">
                    <Button type="primary" icon="android-add" @click="handleAdd">新增</Button>
                    <Button :disabled="currentRow === null" type="primary" icon="edit" class="ml10" @click="editParamType">编辑</Button>
                    <Button type="primary" class="ml10" @click="importDict">导入</Button>
                </div>
            </Table> -->
            <ag-grid
                ref="girdRef"
                height="500"
                :isCard="false"
                rowSelection="single"
                :columnsForIview="columns1"
                :rowData="data1"
                @rowClicked="handleCurrentChange"
            >
                <div slot="header" style="padding: 10px;">
                    <Button type="primary" icon="android-add" @click="handleAdd">新增</Button>
                    <Button :disabled="currentRow === null" type="primary" icon="edit" class="ml10" @click="editParamType">编辑</Button>
                    <!-- <Button type="primary" @click="modal3 = true;">清除快码缓存</Button> -->
                    <!-- <Button type="primary" :loading="loading" @click="exportDict('')">导出</Button> -->
                    <Button type="primary" class="ml10" @click="importDict">导入</Button>
                </div>
            </ag-grid>
            </Col>
            <Col span="12">
            <Form :model="form2" :label-width="100">
                <Row>
                    <Col span="10">
                    <FormItem label="条目编码">
                        <Input type="text" v-model="form2.value1"></Input>
                    </FormItem>
                    </Col>
                    <Col span="10">
                    <FormItem label="条目名称">
                        <Input type="text" v-model="form2.value2"></Input>
                    </FormItem>
                    </Col>
                    <Col span="2">
                    <Button type="primary" @click="sysParamSelect2">查询</Button>
                    </Col>
                </Row>
            </Form>
            <!-- <Table highlight-row border :columns="columns2" @on-row-click="handleCurrentChange2" :data="data2">
                <div slot="header" style="padding: 0 10px;">
                    <Button type="primary" :disabled="currentRow === null" icon="android-add" @click="handleAdd2">新增</Button>
                    <Button :disabled="currentRow2 === null" type="primary" @click="editParamType2" icon="edit">编辑</Button>
                </div>
            </Table> -->
            <ag-grid
                ref="girdRef2"
                height="500"
                :isCard="false"
                rowSelection="single"
                :columnsForIview="columns2"
                :rowData="data2"
                @rowClicked="handleCurrentChange2"
            >
                <div slot="header" style="padding: 10px;">
                    <Button type="primary" :disabled="currentRow === null" icon="android-add" @click="handleAdd2" style="margin-right:10px;">新增</Button>
                    <Button :disabled="currentRow2 === null" type="primary" @click="editParamType2" icon="edit">编辑</Button>
                </div>
            </ag-grid>
            </Col>
        </Row>
        <Modal v-model="modal1" :mask-closable="false" :title="addOrEitTitle" :loading="loading" @on-ok="insertParamType" @on-cancel="cancelParamType" ok-text="提交" cancel-text="取消">
            <Form ref="formItem" :model="formItem" :label-width="80">
                <FormItem :label="this.$t('SysParam.paramTypeCode')" prop="paramTypeCode" :rules="{required: true, message: '不能为空'}">
                    <m-input v-model.trim="formItem.paramTypeCode" :readonly="isUpdateType"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.paramTypeName')" prop="paramTypeName" :rules="{required: true, message: '不能为空'}">
                    <m-input v-model.trim="formItem.paramTypeName" :readonly="isUpdateType"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.paramTypeDesc')" prop="paramTypeDesc" :rules="{required: true, message: '不能为空'}">
                    <m-input v-model.trim="formItem.paramTypeDesc"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.startDate')" prop="startDate" :rules="{ required: true, message: this.$t('common.not_empty_require') }">
                    <Date-picker type="date" :transfer='true' style="width: 200px" placement="top" v-model="formItem.startDate" :readonly="isUpdateType">
                    </Date-picker>
                </FormItem>
                <FormItem :label="this.$t('SysParam.endDate')" prop="endDate">
                    <Date-picker type="date" :transfer='true' style="width: 200px" placement="top" v-model="formItem.endDate">
                    </Date-picker>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="modal2" :mask-closable="false" :title="addOrEitTitle" :loading="loading" width="720" @on-ok="insertParamType2" @on-cancel="cancelParamType2" ok-text="提交" cancel-text="取消">
            <Form ref="formItem2" :model="formItem2" :label-width="80" :rules="formItem2_form_ruleValidate">
                <FormItem :label="this.$t('SysParam.paramValueCode')" prop="paramValueCode">
                    <m-input v-model.trim="formItem2.paramValueCode"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.paramTypeCode')" prop="paramTypeCode">
                    <m-input v-model.trim="formItem2.paramTypeCode" :readonly="true"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.paramValueName')" prop="paramValueName">
                    <m-input v-model.trim="formItem2.paramValueName"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.paramValueDesc')" prop="paramValueDesc">
                    <m-input v-model.trim="formItem2.paramValueDesc"></m-input>
                </FormItem>
                <FormItem label="英文名称" prop="paramValueDescEN">
                    <m-input v-model.trim="formItem2.paramValueDescEN"></m-input>
                </FormItem>
                <FormItem label="泰语" prop="paramValueDescTH">
                    <m-input v-model.trim="formItem2.paramValueDescTH"></m-input>
                </FormItem>
                <FormItem label="越南语" prop="paramValueDescVN">
                    <m-input v-model.trim="formItem2.paramValueDescVN"></m-input>
                </FormItem>
                <FormItem :label="this.$t('SysParam.bj')">
                    <m-input v-model="formItem2.paramValue"></m-input>
                </FormItem>
                <Row>
                    <Col span="8">
                        <FormItem :label="this.$t('SysParam.paramSort')" prop="attribute9">
                            <m-input v-model="formItem2.attribute9" number :maxlength="16"></m-input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="this.$t('SysParam.y1')" prop="attribute1">
                            <m-input v-model="formItem2.attribute1"></m-input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="this.$t('SysParam.y2')" prop="attribute2">
                            <m-input v-model="formItem2.attribute2"></m-input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <FormItem :label="this.$t('SysParam.y3')" prop="attribute3">
                            <m-input v-model="formItem2.attribute3"></m-input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="this.$t('SysParam.y4')" prop="attribute4">
                            <m-input v-model="formItem2.attribute4"></m-input>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="this.$t('SysParam.y5')" prop="attribute5">
                            <m-input v-model="formItem2.attribute5"></m-input>
                        </FormItem>
                    </Col>
                </Row>
                <div v-if="!isUpdateType">
                    <!--  新增 -->
                    <!-- <FormItem :label="this.$t('SysParam.paramValueDEV')" prop="paramValueDEV">
                        <m-input v-model="formItem2.paramValueDEV"></m-input>
                    </FormItem>
                    <FormItem :label="this.$t('SysParam.paramValueSIT')" prop="paramValueSIT">
                        <m-input v-model="formItem2.paramValueSIT"></m-input>
                    </FormItem>
                    <FormItem :label="this.$t('SysParam.paramValueUAT')" prop="paramValueUAT">
                        <m-input v-model="formItem2.paramValueUAT"></m-input>
                    </FormItem>
                    <FormItem :label="this.$t('SysParam.paramValuePDT')" prop="paramValuePDT">
                        <m-input v-model="formItem2.paramValuePDT"></m-input>
                    </FormItem> -->
                </div>
                <div v-else>
                    <!-- 编辑 -->
                    <!-- <FormItem :label="this.$t('SysParam.paramValueDEV')" prop="paramValue">
                        <m-input v-model="formItem2.paramValue"></m-input>
                    </FormItem> -->
                </div>
                <FormItem :label="this.$t('SysParam.startDate')" prop="startDate">
                    <Date-picker type="date" format="yyyy-MM-dd" :transfer='true' style="width: 200px" placement="top" v-model="formItem2.startDate"></Date-picker>
                </FormItem>
                <FormItem :label="this.$t('SysParam.endDate')" prop="endDate">
                    <Date-picker type="date" format="yyyy-MM-dd" :transfer='true' style="width: 200px" placement="top" v-model="formItem2.endDate"></Date-picker>
                </FormItem>
            </Form>
        </Modal>

        <Modal  v-model="modal3" :width="500" title="清除缓存">
            请输入字典编码：<Input type="text" style="width:150px;" v-model="dictCode"></Input>
            
            <Button type="primary" :loading="loading" @click="releaseLockPuissant">清除</Button>
            <div slot="footer"></div>
        </Modal>

        <Modal v-model="importDictModal.show" 
               title="字典导入"
               width="400">
            <Upload
                action="/gscint/sys/sysParam/importSysParams"
                :format="['xls']"
                :show-upload-list="false"
                :before-upload="importBeforeUpload"
                :on-success="importSuccess"
                :on-error="importError"
                :on-format-error="importFormatError">
                <Button icon="ios-cloud-upload-outline" :loading="loading">上传文件</Button>
            </Upload>
            <a style="margin-top:10px;" href="javascript:;" @click="exportDict('GSCDictImportTemplate')">下载导入模板</a>
            <div slot="footer"></div>
        </Modal>
    </section>
</template>
<script>
import api from '@/modules/globalprotal/api/param';
import axios from 'axios';
import { formatDateTime } from '@/utils/datetime-format';
import AgGrid from "@/components/ag-grid/index.vue";


export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            importDictModal: {
                show: false,
            },
            selection: [],
            loading: false,
            dictCode: '',
            modal3: false,
            columns1: [
                // {
                //     type: 'selection',
                //     width: 35,
                //     align: 'center'
                // },
                {
                title: this.$t('SysParam.paramTypeCode'),
                minWidth: 150,
                key: 'paramTypeCode',
            }, {
                title: this.$t('SysParam.paramTypeName'),
                key: 'paramTypeName',
                tooltipField: 'paramTypeName',
            }, {
                title: this.$t('SysParam.paramTypeDesc'),
                key: 'paramTypeDesc',
                tooltipField: 'paramTypeDesc',
            }, {
                title: this.$t('SysParam.startDate'),
                key: 'startDate',
                width: 90,
                align: 'center'
            },
            {
                title: '操作',
                key: 'other',
                width: 90,
                align: 'center',
                render: (h, params) => {
                    return h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.exportDict(params.row.paramTypeCode);
                            }
                        }
                    }, '导出')
                }
            }
            // , {
            //     title: this.$t('SysParam.endDate'),
            //     key: 'endDate'
            // }
            ],
            data1: [],
            form1: {},
            columns2: [{
                title: this.$t('SysParam.paramValueCode'),
                key: 'paramValueCode',
                width: 90,
                align: 'center'
            },
            {
                title: this.$t('SysParam.paramTypeCode'),
                key: 'paramTypeCode',
                width: 200
            },
            {
                title: this.$t('SysParam.paramValueName'),
                key: 'paramValueName',
                tooltipField: 'paramValueName',
            },
            {
                title: this.$t('SysParam.paramValueDesc'),
                key: 'paramValueDesc',
                width: 60,
                align: 'center',
                tooltipField: 'paramValueDesc',
            },
            {
                title: this.$t('SysParam.paramValue'),
                key: 'attribute10',
                width: 40,
                align: 'center'
            },
            {
                title: this.$t('SysParam.remark'),
                key: 'paramValue',
                tooltipField: 'paramValue',
            }],
            data2: [],
            form2: {},
            formItem: {},
            formItem2: {},
            modal1: false,
            modal2: false,
            currentRow: null,
            currentRow2: null,
            loading: false,
            loadingParamValue: true,
            isUpdateType: false,
            isUpdateValue: false,
            addOrEitTitle: '',
            paramTypeId: '',
            paramTypeCode: '',
            paramsEnv: '',
            formItem2_form_ruleValidate: {
                paramValueCode: [
                    { required: true, message: this.$t('common.not_empty_require'), trigger: 'change' }
                ],
                paramValueName: [
                    { required: true, message: this.$t('common.not_empty_require'), trigger: 'change' }
                ],
                paramValueDesc: [
                    { required: true, message: this.$t('common.not_empty_require'), trigger: 'change' }
                ],
                paramValue: [
                    { required: true, message: this.$t('common.not_empty_require'), trigger: 'change' }
                ],
                // attribute9: [
                //     { required: true, type: 'number', trigger: 'blur', message: this.$t('common.not_empty_require_number') }
                // ], // 排序
                startDate: [
                    { required: true, type: 'date', trigger: 'blur', message: this.$t('common.not_empty_require') }
                ]
                // endDate: [
                //     { required: true, type: 'date', message: this.$t('common.not_empty_require'), trigger: 'change' }
                // ]
            }

        };
    },
    watch: {
        'formItem.startDate': function (newValue, oldValue) {
            console.log('startDate_newValue:', newValue, 'oldValue:', oldValue);
            if (newValue) {
                // this.formItem.startDate = newValue;
            }
        },
        'formItem.endDate': function (newValue, oldValue) {
            console.log('endDate_newValue:', newValue, 'oldValue:', oldValue);
            if (newValue) {
                // this.formItem.endDate = newValue;
            }
        }
    },
    methods: {
        sysParamSelect() {
            let form1 = {
                paramTypeCode: this.form1.value1,
                paramTypeName: this.form1.value2
            };
            this.loading = true;
            axios.post(api.sysParamSelectParamType, form1).then(resp => {
                const { success, data, msg } = resp.data;
                if (success) {
                    this.data1 = data;
                } else {
                    this.$Message.error(msg);
                }
            })
                .finally(() => {
                    this.loading = false;
                });
        },

        sysParamSelect2() {
            let form2 = {
                paramValueCode: this.form2.value1,
                paramValueName: this.form2.value2,
                paramTypeId: this.paramTypeId
            };
            axios.post(api.sysParamSelectParamValue, form2).then(resp => {
                const { success, data, msg } = resp.data;
                if (success) {
                    this.data2 = data;
                } else {
                    this.$Message.error(msg);
                }
            })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleCurrentChange({ data: currentRow }) {
            console.log('handleCurrentChange_currentRow:', currentRow);
            this.currentRow = currentRow;
            this.paramTypeId = currentRow.paramTypeId;
            this.paramTypeCode = currentRow.paramTypeCode;
            axios.post(api.sysParamSelectParamValue, currentRow).then(resp => {
                this.data2 = resp.data.data;
            });
        },
        qryTable2Data() {
            /** 新增成功后从新请求数据 */
            axios.post(api.sysParamSelectParamValue, this.currentRow).then(resp => {
                debugger;
                this.data2 = resp.data.data;
            });
        },
        handleCurrentChange2({ data: currentRow2 }) {
           // this.paramsEnv = currentRow2.paramValueEnv;
            this.currentRow2 = currentRow2;
        },

        insertParamType() {
            var self = this;
            if (this.isUpdateType) { // 编辑
                this.$refs.formItem.validate(valid => {
                    console.log('valid', valid);
                    if (valid) {
                        // let noSelectDate = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
                        // if (!noSelectDate.test(this.formItem.startDate)) { // 选择了开始日期
                        //     this.formItem.startDate = formatDateTime(new Date(this.formItem.startDate), 'yyyy-MM-dd');
                        // } else {
                        //     this.formItem.startDate = this.formItem.startDate.match(noSelectDate)[0];
                        // }
                        // if (!noSelectDate.test(this.formItem.endDate)) { // 选择了结束日期
                        //     this.formItem.endDate = formatDateTime(new Date(this.formItem.endDate), 'yyyy-MM-dd');
                        // } else {
                        //     this.formItem.endDate = this.formItem.endDate.match(noSelectDate)[0];
                        // }
                        this.formItem.startDate = this.formItem.startDate ? formatDateTime(new Date(this.formItem.startDate), 'yyyy-MM-dd') : '';
                        this.formItem.endDate = this.formItem.endDate ? formatDateTime(new Date(this.formItem.endDate), 'yyyy-MM-dd') : '';
                        this.formItem.paramTypeId = this.currentRow.paramTypeId;
                        let typeUrl = api.sysParamUpdateParamType;
                        console.log('typeUrl,this.formItem::', typeUrl, this.formItem);
                        this.loading = true;
                        axios.post(typeUrl, this.formItem).then(resp => {
                            const { success, msg: content } = resp.data;
                            if (success) {
                                // this.$Notice.info({
                                //     title: resp.msg,
                                //     desc: ''
                                // });
                                this.$Modal.success({
                                    content,
                                });
                                setTimeout(() => {
                                    this.modal1 = false;
                                }, 500);
                                this.sysParamSelect();
                            } else {
                                this.$Notice.error({
                                    title: content,
                                    desc: ''
                                });
                            }
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                });
            } else { // 新增
                this.$refs.formItem.validate(valid => {
                    if (valid) {
                        // let noSelectDate = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
                        // if (!noSelectDate.test(this.formItem.startDate)) { // 选择了开始日期
                        //     this.formItem.startDate = formatDateTime(new Date(this.formItem.startDate), 'yyyy-MM-dd');
                        // } else {
                        //     this.formItem.startDate = this.formItem.startDate.match(noSelectDate)[0];
                        // }
                        // if (!noSelectDate.test(this.formItem.endDate)) { // 选择了结束日期
                        //     this.formItem.endDate = formatDateTime(new Date(this.formItem.endDate), 'yyyy-MM-dd');
                        // } else {
                        //     this.formItem.endDate = this.formItem.endDate.match(noSelectDate)[0];
                        // }
                        this.formItem.startDate = this.formItem.startDate ? formatDateTime(new Date(this.formItem.startDate), 'yyyy-MM-dd') : '';
                        this.formItem.endDate = this.formItem.endDate ? formatDateTime(new Date(this.formItem.endDate), 'yyyy-MM-dd') : '';
                        this.formItem.paramTypeId = '';
                        let typeUrl = api.sysParamInsertParamType;
                        console.log('typeUrl,this.formItem', typeUrl, this.formItem);
                        this.loading = true;
                        axios.post(typeUrl, this.formItem).then(resp => {
                            const { success, data, msg } = resp.data;
                            if (success) {
                                this.$Notice.info({
                                    title: data,
                                    desc: ''
                                });
                                setTimeout(() => {
                                    this.modal1 = false;
                                }, 500);
                                this.sysParamSelect();
                            } else {
                                this.$Notice.error({
                                    title: msg,
                                    desc: ''
                                });
                            }
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                });
            }
        },

        insertParamType2() {
            if (this.formItem2.attribute9 && this.formItem2.attribute9.length > 0) {
                let num = Number(this.formItem2.attribute9);
                if (Number.isNaN(num)) {
                    // 输入的是非数字类型
                    this.$Modal.error({
                        content: '排序请输入数字'
                    });
                    this.loading = false;
                    return false;
                }
            }
            if (!this.isUpdateType) { // 新增
                this.$refs.formItem2.validate(valid => {
                    if (valid) {
                        let typeUrl = api.sysParamInsertParamValue;
                        this.formItem2.startDate = this.formItem2.startDate ? formatDateTime(new Date(this.formItem2.startDate), 'yyyy-MM-dd') : '';
                        this.formItem2.endDate = this.formItem2.endDate ? formatDateTime(new Date(this.formItem2.endDate), 'yyyy-MM-dd') : '';
                        // let dataValue = {
                        //     paramValueCode: this.formItem2.paramValueCode,
                        //     paramValueName: this.formItem2.paramValueName,
                        //     paramValueDesc: this.formItem2.paramValueDesc,
                        //     endDate: this.formItem2.endDate,
                        //     startDate: this.formItem2.startDate,
                        //     paramTypeId: this.paramTypeId
                        // };
                        let params = this.formItem2;
                        params['paramTypeId'] = this.paramTypeId;
                        console.log('dataValue::', params);
                        this.loading = true;
                        axios.post(typeUrl, params).then(resp => {
                            debugger;
                            const { success, msg: content } = resp.data;
                            if (success) {
                                this.$refs.formItem2.resetFields();
                                this.modal2 = false;
                                this.qryTable2Data();
                                this.$Modal.success({
                                    content,
                                });
                            } else {
                                this.formItem2.startDate = this.formItem2.startDate ? new Date(this.formItem2.startDate) : '';
                                this.formItem2.endDate = this.formItem2.endDate ? new Date(this.formItem2.endDate) : '';
                                this.$Modal.error({
                                    content,
                                });
                            }
                        }).catch(() => {
                            this.$Modal.error({
                                content: '提交失败'
                            });
                            this.modal2 = false;
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                });
            } else { // 编辑
                this.$refs.formItem2.validate(valid => {
                    console.log('valid', valid);
                    if (valid) {
                        // let noSelectDate = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/;
                        // if (!noSelectDate.test(this.formItem2.startDate)) { // 选择了开始日期
                        //     this.formItem2.startDate = formatDateTime(new Date(this.formItem2.startDate), 'yyyy-MM-dd');
                        // } else {
                        //     this.formItem2.startDate = this.formItem2.startDate.match(noSelectDate)[0];
                        // }
                        // if (!noSelectDate.test(this.formItem2.endDate)) { // 选择了结束日期
                        //     this.formItem2.endDate = formatDateTime(new Date(this.formItem2.endDate), 'yyyy-MM-dd');
                        // } else {
                        //     this.formItem2.endDate = this.formItem2.endDate.match(noSelectDate)[0];
                        // }
                        this.formItem2.startDate = this.formItem2.startDate ? formatDateTime(new Date(this.formItem2.startDate), 'yyyy-MM-dd') : '';
                        this.formItem2.endDate = this.formItem2.endDate ? formatDateTime(new Date(this.formItem2.endDate), 'yyyy-MM-dd') : '';
                        let typeUrl = api.sysParamUpdateParamValue;
                        // let dataValue = {
                        //     paramValueCode: this.formItem2.paramValueCode,
                        //     paramValueName: this.formItem2.paramValueName,
                        //     paramValueDesc: this.formItem2.paramValueDesc,
                        //     endDate: this.formItem2.endDate,
                        //     startDate: this.formItem2.startDate,
                        //     paramTypeId: this.paramTypeId,
                        //     paramValue: this.formItem2.paramValue,
                        //    // paramValueEnv: this.formItem2.paramValueEnv,
                        //     paramValueId: this.formItem2.paramValueId
                        // };
                        let params = this.formItem2;
                        params['paramTypeId'] = this.paramTypeId;
                        console.log('typeUrl,dataValue', typeUrl, params);
                        this.loading = true;
                        axios.post(typeUrl, params).then(resp => {
                            const { data, msg: content } = resp.data;
                            if (data) {
                                this.$refs.formItem2.resetFields();
                                this.modal2 = false;
                                this.sysParamSelect2();
                                this.$Modal.success({
                                    content,
                                });
                            } else {
                                this.$Modal.error({
                                    content: '提交失败'
                                });
                                this.modal2 = false;
                            };
                        })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                });
            }
            this.currentRow2 = null;
        },

        cancelParamType() {},

        cancelParamType2() {},
        handleAdd() { // 新增
            this.addOrEitTitle = '新增';
            this.$refs.formItem.resetFields();
            this.isUpdateType = false;
            this.modal1 = true;
        },
        handleAdd2() { // 新增2
            this.addOrEitTitle = '新增';
            this.$refs.formItem2.resetFields();
            this.formItem2.paramTypeCode = this.paramTypeCode;
            this.isUpdateType = false;
            this.modal2 = true;
            this.currentRow2 = null;
        },

        editParamType() { // 编辑
            console.log('edit11this.currentRow:', this.currentRow);
            this.addOrEitTitle = '编辑';
            this.formItem = this.currentRow;
            this.isUpdateType = true;
            this.modal1 = true;
        },

        editParamType2() { // 编辑
            console.log('edit22this.currentRow:', this.currentRow);
            this.addOrEitTitle = '编辑';
            this.formItem2 = this.currentRow2;
            this.formItem2.startDate = this.formItem2.startDate ? new Date(this.formItem2.startDate) : '';
            this.formItem2.endDate = this.formItem2.endDate ? new Date(this.formItem2.endDate) : '';
            // this.formItem2.attribute9 = this.formItem2.attribute9 ? Number(this.formItem2.attribute9) : '';
            this.isUpdateType = true;
            this.modal2 = true;
        },
        releaseLockPuissant () {
            this.loading = true;
            axios.get('/gscint/distributedLock/releaseLockPuissant', {
                params: {
                    key: `GSC_FAST_CODE_TIME_DIRECT_${this.dictCode}`
                }
            })
            .then((content) => {
                this.$Modal.warning({
                    content
                });
            })
            .catch(() => {
                this.showErrorTips();
            })
            .finally(() => {
                this.loading = false;
            });
        },
        onSelectionChange (selection) {
            this.selection = selection;
        },
        exportDict (paramTypeCode = '') {
            // this.selection.forEach((item) => {
            //     paramTypeCode.push(item.paramTypeCode);
            // });
            // paramTypeCode = paramTypeCode.join();
            this.loading = true;
            axios.get('/gscint/sys/sysParam/exportSysParams', {
                params: {
                    paraJson: JSON.stringify(
                        {
                            paramTypeCode
                        }
                    )
                },
                responseType: 'blob'
            })
            .then((res) => {
                this.loading = false;
                this.downloadFile(res, '字典.xlsx');
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        importDict () {
            this.importDictModal.show = true;
        },
        importBeforeUpload () {
            this.loading = true;
        },
        importSuccess (response) {
            debugger;
            this.loading = false;
            if (response.success) {
                this.$Modal.success({
                    content: '字典导入成功'
                });
                this.importDictModal.show = false;
                this.sysParamSelect();
            } else {
                this.$Modal.error({
                    content: response.errorCode
                });
            }
        },
        importError () {
            this.loading = false;
            this.$Modal.error({
                content: this.$t('common.error1')
            });
        },
        importFormatError () {
            this.$Modal.warning({
                content: '请上传正确的导入模板'
            });
        }
    },
    mounted() {
        axios.post(api.sysParamSelectParamType, {}).then(resp => {
            const { success, data, msg } = resp.data;
            if (success) {
                this.data1 = data;
            } else {
                this.$Message.error(msg);
            }
        });
    }
};

</script>
<style lang='less' scoped>
.wrapper {
    padding: 10px;
}
.ml10 {
    margin-left: 10px;
}
</style>
